import { useEffect } from 'react';
import { SITE } from './siteInfo';
import TermsOfUse from './TermsOfUse';
import PrivacyPolicy from './PrivacyPolicy';
import AccessibilityStatement from './AccessibilityStatement';

// העמודים המשפטיים - כתובות קבועות (/terms, /privacy, /accessibility), כדי שאפשר לקשר אליהם מכל מקום.
// ZolBakfarApp מציג אותם לפי window.location.pathname (השרת מחזיר index.html לכל כתובת).

export const LEGAL_ROUTES = {
  '/terms':         { title: 'תנאי שימוש', Component: TermsOfUse },
  '/privacy':       { title: 'מדיניות פרטיות', Component: PrivacyPolicy },
  '/accessibility': { title: 'הצהרת נגישות', Component: AccessibilityStatement },
};

export const legalRouteFor = (pathname) => LEGAL_ROUTES[pathname.replace(/\/+$/, '') || '/'] || null;

const s = {
  page:    { maxWidth: 820, margin: '0 auto', padding: '24px 16px 48px' },
  home:    { display: 'inline-flex', alignItems: 'center', gap: 8, fontWeight: 700, fontSize: 18, color: '#1f2328', textDecoration: 'none' },
  logo:    { width: 32, height: 32, borderRadius: 8 },
  article: { background: '#fff', border: '1px solid #e5e7eb', borderRadius: 14, padding: '24px 22px', marginTop: 16, lineHeight: 1.75 },
  title:   { margin: '0 0 4px', fontSize: 28 },
  updated: { margin: '0 0 20px', color: '#59636e', fontSize: 14 },
  links:   { display: 'flex', justifyContent: 'center', gap: 16, flexWrap: 'wrap', padding: '8px 16px 20px', fontSize: 14, color: '#59636e' },
};

// קישורים בתחתית כל עמוד
export const LegalLinks = () => (
  <nav style={s.links} aria-label="מידע משפטי ונגישות">
    {Object.entries(LEGAL_ROUTES).map(([path, r]) => <a key={path} href={path}>{r.title}</a>)}
    <span>© {new Date().getFullYear()} {SITE.name}</span>
  </nav>
);

const LegalPage = ({ route }) => {
  const { title, Component } = route;

  useEffect(() => {
    const prev = document.title;
    document.title = `${title} - ${SITE.name}`;
    return () => { document.title = prev; };
  }, [title]);

  return (
    <div style={s.page}>
      <a href="#main-content" className="skip-link">דילוג לתוכן הראשי</a>
      <header>
        <a href="/" style={s.home}>
          <img src="/logo192.png" alt="" style={s.logo} />
          חזרה
        </a>
      </header>
      <main id="main-content" tabIndex={-1} style={{ outline: 'none' }}>
        <article style={s.article}>
          <Component titleStyle={s.title} updatedStyle={s.updated} />
        </article>
      </main>
      <footer><LegalLinks /></footer>
    </div>
  );
};

export default LegalPage;
